__webpack_require__.p = "https://bmidxbirelandplprod.netlify.app/";